import { render } from "./UserEdit.vue?vue&type=template&id=6f3ed9e4&scoped=true&ts=true"
import script from "./UserEdit.vue?vue&type=script&lang=ts"
export * from "./UserEdit.vue?vue&type=script&lang=ts"

import "./UserEdit.vue?vue&type=style&index=0&id=6f3ed9e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3ed9e4"]])

export default __exports__